import styled from 'styled-components'
import { BLUE, LIGHTYELLOW } from '../../../../styles/colors.style'
import { breakpoints } from '../../../../constants/breakpoits.constants'
import { isBlackFriday } from '../../../../helpers/isBlackFriday'

export const StyledForm = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	background: ${isBlackFriday? 'linear-gradient(to bottom, #000000, #FFD017);' : BLUE };
	border-radius: 5px;
	padding: 15px;
	box-shadow: 0 0px 9px 0px rgba(0, 0, 0, 0.5);
	padding-bottom: 45px;

	form {
		width: 100%;
	}

	.title-ticket-sale {
		line-height: 1em;
		font-weight: bold;
		text-align: center;

		span {
			display: none;
		}
	}

	@media (max-width: ${breakpoints.MOBILE}px) {
		margin-top: 0px;
	}

	.white {
		color: #fff;
	}

	.error {
		color: ${LIGHTYELLOW};
	}

	.grow-1 {
		flex-grow: 1;
	}
`

export const StyledBannerContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	margin-bottom: 10px;
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		min-width: 400px;
	}
	.message {
		font-size: large;
		margin-bottom: 7px;
	}

	.banner-image {
		max-width: 100%;
		display: block;
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
		}
	}
`

export const StyledContainer = styled.div`
	@media (min-width: ${breakpoints.MOBILE}px) {
		margin-top: initial;
		padding: initial;
		width: 84%;
	}
`

export const StyledBonusPointsContainer = styled.div`
	align-items: center;
	color: white;
	display: flex;
	justify-content: center;
	margin: 15px 0px;
	text-align: center;
`

export const StyledContainerReverseRounded = styled.div`
	padding: 5px 7px;
	position: absolute;
	z-index: 2;
	top: 22%;
	right: 35px;
	transform: translate(0, -50%);
	width: 45px;
	height: 45px;
	border: 1px solid #666;
	border-radius: 100%;
	background: #fff;

	@media (min-width: ${breakpoints.MOBILE}px) {
		background: none;
		border-radius: 0;
		border: 0;
		cursor: pointer;
		position: unset;
		transform: translate(0, 0);
	}

	.ico-reverse {
		transform: rotate(270deg);
		color: #517abc;
		font-size: 22px;
		height: 100%;
		width: 27px;
		display: flex;
		justify-content: center;
		align-items: center;

		@media (min-width: ${breakpoints.MOBILE}px) {
			transform: rotate(0);
			color: #fff;
		}
	}
`
